<app-header></app-header>
<app-navbar [selected]="'administration'"></app-navbar>

<div class="d-flex">
  <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
    <app-sidebar [items]="links"></app-sidebar>
  </aside>
  <main class="ps-5 w-100 ">
    <div class="row">
      <div class="col-md-6 fw-bold">
        <label for="basic-url" class="form-label color-text"> {{ 'tariffUsers.text-usuario' | translate }} </label>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn custombutton" (click)="checkRow()">{{ 'tariffUsers.newUser' | translate
          }}</button>
      </div>
    </div>

    <div class="col-md-2 mx-2 mb-3">
      <label class="form-label color-text" for="buscar">{{ 'tariffUsers.label-buscar' | translate }}</label>
      <input type="text" placeholder="" id="buscar" name="buscar" class="form-control modelinput color-text"
        ng-reflect-name="buscar" (change)="handleFindNameOrIdp($event)">
    </div>

    @if (this.userReponse.listUser.length > 0) {
    <div>
      <fieldset>
        <table class="table text-center" role="table" [attr.aria-label]="'tariffUsers.text-usuario' | translate">
          <thead>
            <tr>
              <th scope="col">
                <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
              </th>
              <th scope="col">{{ 'tariffUsers.ipdUser' | translate }}</th>
              <th scope="col">{{ 'tariffUsers.nombreApelidos' | translate }}</th>
              <th scope="col">{{ 'tariffUsers.rol' | translate }}</th>
              <th scope="col">{{ 'tariffUsers.checkActive' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of this.userReponse.listUser; let i = index"
              [ngClass]="{'resaltado': selectedRowId === user.idTariffAgent}">
              <td role="cell">
                <input type="radio" [id]="'radio-' + user.idTariffAgent" name="flexRadioDefault"
                  [checked]="selectedRowId === user.idTariffAgent" (click)="checkRow(user)">
                <label [for]="'radio-' + user.idTariffAgent" class="visually-hidden">
                  {{ "seleccionarFilaCon" | translate }}:
                  {{ 'tariffUsers.ipdUser' | translate }} {{ user.idTariffAgent }},
                  {{ 'tariffUsers.nombreApelidos' | translate }} {{ user.name }} {{ user.surname }},
                  {{ 'tariffUsers.rol' | translate }} {{ isAdminActive(user) }},
                  {{ 'tariffUsers.checkActive' | translate }} {{ user.active ? 'Activo' : 'Inactivo' }}
                </label>
              </td>
              <td role="cell"><span>{{ user.idTariffAgent }}</span></td>
              <td role="cell"><span>{{ user.name }} {{ user.surname }}</span></td>
              <td role="cell"><span>{{ isAdminActive(user) }}</span></td>
              <td role="cell">
                @if(user.active) {
                <span>Activo</span>
                }@else{
                <span>Inactivo</span>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </fieldset>

      <div class="mt-2" *ngIf="this.userReponse.pageDto">
        <app-paginator [isStart]="this.userReponse.pageDto.start" [isEnd]="this.userReponse.pageDto.end"
          [currentPage]="this.userReponse.pageDto.currentPage" [totalPages]="this.userReponse.pageDto.pages"
          [numberRecord]="this.userReponse.pageDto.records" [sizePage]="this.userReponse.pageDto.pageSize">
        </app-paginator>
      </div>

      @if (this.selectedRowId !== null || this.creatingUser) {
      <div class="separator mt-5"></div>

      <div>
        <form [formGroup]="validateForm" (ngSubmit)="createOrUpdateUser()">
          <div class="mt-5">
            @if(this.creatingUser){
            <h2 class="textformat mb-4 color-text">{{ 'tariffUsers.newUser' | translate }}
            </h2>
            }@else {
            <h2 class="textformat mb-4 color-text">{{ 'tariffUsers.updateUser' | translate
              }}</h2>
            }
          </div>

          <div class="row">
            <!-- Employee Number -->
            <div class="col-md-6 mb-3 color-text">
              <fieldset [attr.disabled]="updateUser ? true : null">
                <label class="form-label" for="idTariffAgent">{{ 'tariffUsers.ipdUser' | translate }}</label>
                <input id="idTariffAgent" name="idTariffAgent" type="text" min="1" class="form-control color-text"
                  (input)="validarDecimales($event)" placeholder="ID Tariff Agent" formControlName="idTariffAgent"
                  [class.input-error]="sharedService.controlInput(validateForm,'idTariffAgent')">
                <app-message-input [form]="validateForm" [field]="'idTariffAgent'"></app-message-input>

              </fieldset>
            </div>

            <!-- Name user 
            <div class="col-md-2 mb-3 color-text">
              <label for="name" class="form-label">{{ 'tariffUsers.name' | translate }}</label>
              <input type="text" class="form-control color-text" id="name" name="name" required formControlName="name">
            </div>

              <input type="text" class="form-control color-text" id="name" required formControlName="name">
            </div>-->

            <!-- Surname user 
            <div class="col-md-2 mb-3 color-text">
              <label for="surname" class="form-label">{{ 'tariffUsers.surname' | translate }}</label>

              <input type="text" class="form-control color-text" id="surname" name="surname" formControlName="surname">
            </div>

              <input type="text" class="form-control color-text" id="surname" required formControlName="surname">
            </div>-->



            <!-- Active Employee Checkbox -->
            <div class="col-md-2 mb-3 color-text">
              <input class="form-check-input mx-3" type="checkbox" id="active" name="active" formControlName="active">
              <label class="form-check-label color-text" for="active">
                {{ 'tariffUsers.checkActive' | translate }}
              </label>
            </div>
          </div>

          <div class="row">
            <!-- List Roles -->
            <div class="col-md-6 mb-3 color-text">
              <label for="functionCode" class="form-label">{{ 'tariffUsers.roles' | translate }}:</label>
              <select id="functionCode" name="functionCode" class="form-select" formControlName="functionCode" multiple>
                @for (rol of this.listRol; track $index) {
                <option [value]="rol" class="color-text">{{ rol }}</option>
                }
              </select>
            </div>
          </div>
          @if(!this.updateUser){
          <button type="submit" class="btn custombutton mt-3">{{ 'tariffUsers.buttonCreate' | translate }}</button>
          }@else {
          <button type="submit" class="btn custombutton mt-3 mx-2">{{ 'tariffUsers.updateUser' | translate }}</button>
          <a type="button" class="btn custombutton mt-3" (click)="deleteUserById()">Delete User</a>
          }

        </form>
      </div>
      }
      <app-alert-component [isOk]="messageVisibility.isSuccessFirst" [isDanger]="messageVisibility.isErrorFirts"
        [message]="errorMessage"
        (close)="messageVisibility.isSuccessFirst = messageVisibility.isErrorFirts = false"></app-alert-component>
    </div>
    } @else if(!this.loadListing) {
    <div class="alert" role="alert" style="background-color: #73EDFF;">
      There are no users for the application
    </div>
    }
  </main>

</div>